module.exports = __webpack_public_path__ + "img/loader.759e52f3.svg";